/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Feat3_TitleInputs */

const es_l7_feat3_title = /** @type {(inputs: L7_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro adecuado`)
};

const gl_l7_feat3_title = /** @type {(inputs: L7_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro axeitado`)
};

const en_l7_feat3_title = /** @type {(inputs: L7_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right insurance`)
};

/**
* | output |
* | --- |
* | "Right insurance" |
*
* @param {L7_Feat3_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_feat3_title = /** @type {((inputs?: L7_Feat3_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Feat3_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_feat3_title(inputs)
	if (locale === "en") return en_l7_feat3_title(inputs)
	return es_l7_feat3_title(inputs)
});